import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { pricingProfileColumns } from 'pricing/components/PricingProfileList';
import { PricingProfileType } from 'pricing/enums';
import { ICorporatePricingProfile } from 'pricing/types';

import { AccessTypeCell, ActionsCell, NameCell } from './cells';

interface IGetColumnDefParams {
  onNameClick: (data: ICorporatePricingProfile) => void;
  projectId: number;
}

export const getColumnDef = ({ onNameClick, projectId }: IGetColumnDefParams): ColDef[] => [
  {
    colId: 'actions',
    width: 50,
    maxWidth: 50,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: {
      projectId,
    },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'accessType',
    headerName: t('headerVisibility'),
    field: 'accessType',
    cellRenderer: AccessTypeCell,
    sortable: false,
    minWidth: 120,
    width: 120,
  },
  { ...pricingProfileColumns.statusColumn, minWidth: 120 },
  {
    colId: 'name',
    headerName: t('headerName'),
    field: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: NameCell,
    cellRendererParams: {
      onNameClick,
    },
    minWidth: 200,
    flex: 1,
  },
  pricingProfileColumns.corporateUserNameColumn,
  pricingProfileColumns.agreementIdColumn,
  {
    colId: 'type',
    headerName: t('headerType'),
    field: 'type',
    valueGetter: ({ data }) =>
      data?.type === PricingProfileType.PROJECT ? t('labelProject') : t('labelDayToDay'),
    sortable: false,
    minWidth: 120,
  },
  pricingProfileColumns.startDateColumn,
  pricingProfileColumns.endDateColumn,
  pricingProfileColumns.createdAtColumn,
  pricingProfileColumns.updatedAtColumn,
];
